import { render, staticRenderFns } from "./UpdateOrderStatus.vue?vue&type=template&id=85f02db2&scoped=true&"
import script from "./UpdateOrderStatus.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOrderStatus.vue?vue&type=style&index=0&id=85f02db2&lang=scss&scoped=true&"
import style1 from "./UpdateOrderStatus.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f02db2",
  null
  
)

export default component.exports